import { useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './DataAvailabilityButton.module.scss';
import Button from '../../../../../common/_custom/Button/Button';
import DataAvailabilityModal from './DataAvailabilityModal';
import { infoPurpleIcon } from '../../../../../assets/hostedassets';
import { DATA_AVAILABILITY_COPY } from '../constants/reconciliationsCopy';

interface DataAvailabilityButtonProps {
    orgId: string;
    className?: string;
}

/** The "ⓘ Data Availability" entry point plus the modal it opens. Opens on click only — never on hover. */
function DataAvailabilityButton({ orgId, className }: Readonly<DataAvailabilityButtonProps>) {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    return (
        <>
            <Button
                type="button"
                buttonRef={buttonRef}
                className={clsx(styles.DataAvailabilityButton, className)}
                icon={<img src={infoPurpleIcon} alt="" aria-hidden="true" className={styles.InfoIcon} />}
                text={DATA_AVAILABILITY_COPY.BUTTON}
                aria-haspopup="dialog"
                aria-expanded={open}
                onClick={() => setOpen(true)}
            />
            {open && <DataAvailabilityModal orgId={orgId} triggerRef={buttonRef} onClose={() => setOpen(false)} />}
        </>
    );
}

export default DataAvailabilityButton;
